

// src/components/CitySelector.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import debounce from 'lodash.debounce';
import { SERVER_URL } from '../../../../../Config/config';

const RedisCitySelector = () => {
  const [query, setQuery] = useState('');
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchCities = async (searchTerm) => {
    if (!searchTerm) {
      setCities([]);
      return;
    }
    try {
      setLoading(true);
      const response = await axios.get(`${SERVER_URL}/api/v1/user/cities`, {
        params: { search: searchTerm }
      });
      setCities(response.data);
    } catch (error) {
      console.error('Error fetching cities:', error);
    } finally {
      setLoading(false);
    }
  };

  // Debounced function
  const debouncedFetchCities = debounce(fetchCities, 300);

  useEffect(() => {
    debouncedFetchCities(query);

    // Cleanup debounce when unmount
    return () => {
      debouncedFetchCities.cancel();
    };
  }, [query]);

  const handleSelectCity = (city) => {
    setSelectedCity(city);
    setQuery(city.name);
    setCities([]); 
  };

  return (
    <div className="flex flex-col items-center p-6">
      <div className="w-full max-w-md">
        <input
          type="text"
          className="w-full border border-gray-300 rounded-lg p-3 shadow-sm focus:outline-none focus:border-blue-500"
          placeholder="Search city..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />

        {loading && <div className="text-center text-gray-500 mt-2">Loading...</div>}

        {cities.length > 0 && (
          <ul className="border border-gray-300 rounded-lg mt-2 shadow-md max-h-60 overflow-y-auto bg-white">
            {cities.map((city) => (
              <li
                key={city.id}
                onClick={() => handleSelectCity(city)}
                className="p-3 hover:bg-blue-100 cursor-pointer"
              >
                {city.name}, {city.country}
              </li>
            ))}
          </ul>
        )}

        {selectedCity && (
          <div className="mt-4 p-4 border border-green-400 bg-green-100 rounded-lg text-green-700">
            Selected City: {selectedCity.name} ({selectedCity.country})
          </div>
        )}
      </div>
    </div>
  );
};

export default RedisCitySelector;
